
import { QuestaoSelecaoEditavel } from '@/dominio/editor/questoes/questao-selecao/QuestaoSelecaoEditavel';
import { defineComponent } from 'vue';
import QuestaoSelecaoVisualizacao from './QuestaoSelecaoVisualizacao.vue';
import QuestaoSelecaoEdicao from './QuestaoSelecaoEdicao.vue';

export default defineComponent({
    name: 'ItemDeQuestaoSelecao',
    components: {
        QuestaoSelecaoVisualizacao,
        QuestaoSelecaoEdicao,
    },
    props: {
        questao: { type: QuestaoSelecaoEditavel, required: true },
        ehPrimeiro: { type: Boolean, required: true },
        ehUltimo: { type: Boolean, required: true },
    },
    data() {
        return { selecionado: false };
    },
    methods: {
        editar(questao: QuestaoSelecaoEditavel) {
            this.$emit('editar', questao);
        },
        excluir(questao: QuestaoSelecaoEditavel) {
            this.$emit('excluir', questao);
        },
        descer(questao: QuestaoSelecaoEditavel) {
            this.$emit('descer', questao);
        },
        subir(questao: QuestaoSelecaoEditavel) {
            this.$emit('subir', questao);
        },
        selecionar(questao: QuestaoSelecaoEditavel) {
            this.$emit('selecionar', questao);
        },
    },
    emits: ['editar', 'excluir', 'descer', 'subir', 'selecionar'],
});
